import { Component, OnInit } from '@angular/core';
//import { Itemcategory } from '../item-category';
import { Itemcategory } from './item-category';
import { ItemcategoryService } from '../item-category/item-category.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AuthService } from '../auth.service';
import { UtilityService } from  '../utility.service';

@Component({
  selector: 'app-item-category',
  templateUrl: './item-category.component.html',
  styleUrls: ['./item-category.component.css']
})
export class ItemCategoryComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  itemcategory = new Itemcategory();  //Po is defined from abobe import po
 public isupdate = false;
  itemcategorys:any= [];
  itemcategorydata: any = {};
  submitted = false;
  itemcategoryForm: FormGroup;
  public FormName = "Add Item Category";
	message: string;	
	totalrecord:number;
 itemcategoryFilter: any = { itemcategoryname: '' };
  constructor(
  private itemcategoryService: ItemcategoryService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
	 private formBuilder: FormBuilder,
	   private util:UtilityService, 
    private location: Location,
	  private auth: AuthService
  ) { }

  ngOnInit() {
    this.getItemcategorys();
	 this.itemcategory.active = 1;
	   this.itemcategoryForm = this.formBuilder.group({			
      itemcategoryname: [this.itemcategory.itemcategoryname,[Validators.required, Validators.required]],
      active: [this.itemcategory.active,[Validators.required, Validators.required]]
    });	
  }

  getItemcategorys() {
    this.spinnerService.show();
    return this.itemcategoryService.getItemcategorys()
               .subscribe(
                itemcategorys => {
                  console.log(itemcategorys);
                  this.itemcategorys = itemcategorys
          this.totalrecord = this.itemcategorys.length;
          this.spinnerService.hide();
                 }
                );
 }
 public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}


onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.itemcategoryForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{    
    if(this.isupdate){
 //     this.stateForm.get('statename').clearValidators();
//			this.stateForm.get('statename').updateValueAndValidity();
      this.update();
    }
    else{
      this.addItemCategory();
    }
  }
}
 addItemCategory() {
 // this.stateForm.get('statename').clearValidators();
 // this.stateForm.get('statename').updateValueAndValidity();
   this.save();
 }
 
  private save(): void {
    this.itemcategorydata = this.itemcategory;
	this.itemcategorydata.createdby = this.auth.currentUserValue.userid
    this.itemcategoryService.AddItemCategory(this.itemcategorydata)
        .subscribe(() => {
			
		this.util.showSuccess("Item Category added successfully.");
		this.getItemcategorys();
     //   this.goBack();  //for Redirecting to the list view    
     this.itemcategory = new Itemcategory(); 
		});
     this.isupdate= false;
  } 


  update(): void {
    //this.submitted = true;
    this.submitted = true;
    this.itemcategorydata = this.itemcategory;
    this.itemcategorydata.modifiedby = this.auth.currentUserValue.userid;
    this.itemcategorydata.modifiedon = Date.now();
    this.itemcategoryService.UpdateItemCategory(this.itemcategorydata)
        .subscribe(() => 
		
		{
		this.util.showSuccess("Item Category update successfully.");
        this.itemcategory = new Itemcategory(); 
        this.isupdate= false;
        this.getItemcategorys();
		});
        this.FormName ="Add Item Cateogry";
  }
 
  delete(itemcategoryid): void {
    this.submitted = true;
    this.itemcategoryService.deleteitemcategory(itemcategoryid)
        .subscribe(()=> 		
		{ 
		
			this.util.showSuccess("Item Category deleted successfully.");
			this.getItemcategorys();
		});
  }
  
  getItemCategory(itemcategoryid) {
  return this.itemcategoryService.getItemcategory(itemcategoryid)
             .subscribe(
               itemcategory => {               
                this.FormName ="Update Item Category";
                 this.itemcategory = itemcategory;
                 this.isupdate=true;
               }
              );
}


}
